module.exports = __webpack_public_path__ + "img/Bodice-Front-B4-Da-Ea.dadb15d4.png";